export enum ResourceTypes {
	SOFTWARE = 'Software',
	HARDWARE = 'Hardware',
	DATABASE = 'Database',
	WORKFLOW = 'Workflow',
	E_LEARNING_PLATFORM = 'E-learning platform',
	WIKI = 'Wiki',
	OTHER = "Other"
}
